import { isDevelopmentEnvironment } from '~/main/environments';

const defaultSrc = [
  'default-src',
  "'self'",
  // Enable for HMR
  isDevelopmentEnvironment() ? "'unsafe-eval'" : '',
].join(' ');

const scriptSrcElem = ['script-src-elem', "'self'", 'https://*.appcues.com'].join(' ');

const frameSrc = ['frame-src', 'https://*.appcues.com'].join(' ');

// Enable '*' so custom logos can be loaded with Jimp
// Also because our 3rd parties have many domains (Appcues, Ably, GA, ...)
const connectSrc = ['connect-src', '*'].join(' ');

const styleSrc = ['style-src', "'unsafe-inline'", '*'].join(' ');

const imgSrc = ['img-src', 'data:', '*'].join(' ');

const fontSrc = ['font-src', '*'].join(' ');

export default [defaultSrc, scriptSrcElem, frameSrc, connectSrc, styleSrc, imgSrc, fontSrc].join(
  ';',
);
